import { inject, Injectable } from '@angular/core';
import { CustomHttpClient } from '../core/httpClient/http-client';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class Sso {
  http = inject(CustomHttpClient);
  private readonly router = inject(Router);
  constructor() {}

  logout() {
    const URLEndpoint = environment.apiSSO + '/api/auth/signout';
    this.http.post(URLEndpoint, {}).subscribe({
      next: (response) => {
        console.log('Logout successful', response);
        this.router.navigate(['/login'], { queryParams: { reason: 'logout' } });
      },
      error: (error) => {
        console.error('Logout failed', error);
      },
    });
  }
}
